/**
 * The parts a page draws on screen beside the card registry's cards, for the
 * live call's `attention.inView` (Phase 7 review of
 * docs/plans/onboarding-harness/phase-07.md): the setup studio's canvas sets
 * the part paths wholly in view while it is drawn, and says when they change,
 * so the studio seat knows what the person can see on the canvas.
 */
type ViewCards = () => readonly string[];

let read: ViewCards | null = null;
const listeners = new Set<() => void>();

/** What a page shows now, by part path; null when it shows none. Setting it is a change. */
export const setLiveViewCards = (next: ViewCards | null): void => {
  read = next;
  noteLiveViewCardsChanged();
};

/** The part paths in view now; none when no page set them. */
export const liveViewCardsNow = (): readonly string[] => read?.() ?? [];

/** What is in view changed: each listener reads again. */
export const noteLiveViewCardsChanged = (): void => {
  for (const listener of listeners) listener();
};

/** Hear each change of what is in view; answers the way to stop. */
export const onLiveViewCardsChanged = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
